// extracted by mini-css-extract-plugin
export var csatScore = "_mk-5";
export var header = "_mk-1";
export var panelWrapper = "_mk-2";
export var postPreview = "_mk-3";
export var rightContent = "_mk-0";
export var wrappingText = "_mk-4";